<!-- 片区维修记录 -->
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="horizontal" :labelCol="{ span: 5 }" :wrapperCol="{ span: 16 }">
        <a-row :gutter="48">
          <!-- 第一排 -->
          <a-col :md="6" :sm="12">
            <a-form-item label="片区选择">
              <a-tree-select :tree-data="zoneTreeData" v-model="query.zoneId" style="width: 100%"
                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search
                treeNodeFilterProp="title"></a-tree-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="事件类型">
              <a-select v-model="query.eventType" placeholder="请选择事件类型" allow-clear>
                <a-select-option v-for="(label, value) in eventTypeMap" :key="value" :value="value">
                  {{ label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="处理状态">
              <a-select v-model="query.status" placeholder="请选择处理状态" allow-clear>
                <a-select-option v-for="(label, value) in processStatusMap" :key="value" :value="value">
                  {{ label }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="查询时间">
              <a-range-picker v-model="queryDateRange" style="width: 100%" format="YYYY-MM-DD"
                :placeholder="['开始日期', '结束日期']" @change="handleTimeChange" allow-clear />
            </a-form-item>
          </a-col>
          <!-- 第二排-操作按钮 -->
          <a-col :md="24" :sm="24">
            <div style="margin-bottom: 20px; display: flex;">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="addOrUpdateHandle()">添加事件</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </div>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" :bordered="true"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 1500 }">
      <span slot="action" slot-scope="text, record">
        <template v-if="record.status == 1">
          <a @click="addOrUpdateHandle(record, 'process')">查看</a>
        </template>
        <template v-else>
          <a @click="addOrUpdateHandle(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="addOrUpdateHandle(record, 'process')">处理</a>
        </template>
      </span>
      <span slot="status" slot-scope="text">
        <a-tag :color="text == 0 ? 'orange' : 'green'">
          {{ processStatusMap[text] || text }}
        </a-tag>
      </span>
    </a-table>
    <maintain-add-or-update ref="addOrUpdate" @refreshDataList="queryList" />
  </a-card>
</template>

<script>

import mixinViewModule from '@/mixin/common' //选项式混合导入
import MaintainAddOrUpdate from './module/MaintainAddOrUpdate'

const eventTypeMap = {
  1: '维修',
  2: '巡线',
  3: '二次供水',
  4: '用户检漏',
  5: '自检查漏',
  6: '农污',
  7: '其它'
}

const processStatusMap = {
  0: '未处理',
  1: '已处理'
}

const columns = [ //表头参数
  {
    title: '所属片区',
    dataIndex: 'zoneName',
    width: 150,
    ellipsis: true
  },
  {
    title: '事件类型',
    dataIndex: 'eventType',
    customRender: (text) => eventTypeMap[text] || text,
    width: 120,
    ellipsis: true
  },
  {
    title: '事件描述',
    dataIndex: 'eventDescription',
    width: 200,
    ellipsis: true
  },
  {
    title: '事件日期',
    dataIndex: 'eventDate',
    width: 150,
    ellipsis: true
  },
  {
    title: '事件地址',
    dataIndex: 'address',
    width: 200,
    ellipsis: true
  },
  {
    title: '处理状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    width: 120,
    ellipsis: true
  },
  {
    title: '处理描述',
    dataIndex: 'processDescription',

    ellipsis: true
  },
  {
    title: '处理人',
    dataIndex: 'conductor',
    width: 120,
    ellipsis: true
  },
  {
    title: '处理日期',
    dataIndex: 'handleTime',
    width: 150,
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    align: 'center',
    fixed: 'right',
    width: 150,
    scopedSlots: { customRender: 'action' },
  }
]

export default {
  mixins: [mixinViewModule],
  name: 'ParallelLargeUser',
  components: {
    MaintainAddOrUpdate
  },
  data () {
    return {
      //needQuery: false, // 是否在created就执行查询操作
      currentId: '',
      queryUrl: '/zone-metering/maintenance-records/page', //查询url
      deleteUrl: '/zone-metering/maintenance-records/delete', //删除url
      query: { //查询对象

      },
      queryDateRange: [], // 时间范围
      eventTypeMap,
      processStatusMap,
      pushTime: [],
      columns,
      queryZoneDateUrl: 'zone-metering/zone-metering',
      zoneTreeData: [], // 片区选项
      treeDefaultExpandedKeys: [], // 片区选项展开
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },
  created () {
    this.getZoneData()
  },
  methods: {
    // 处理时间变化
    handleTimeChange (dates, dateStrings) {
      if (dates && dates.length > 0) {
        this.query.queryBeginDate = dateStrings[0]
        this.query.queryEndDate = dateStrings[1]
      } else {
        this.query.queryBeginDate = undefined
        this.query.queryEndDate = undefined
      }
    },
    // 重置
    resetList () {
      this.pagination.current = 1
      this.query = {}
      this.queryDateRange = []
      this.selectedRows = []
      this.queryList()
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    addOrUpdateHandle (record, type) {
      this.$refs.addOrUpdate.init(record, type)
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>